import React from 'react';
import { Flex, VStack } from '@chakra-ui/react';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';
import { LuUserX, LuArrowLeft } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';

const CreateAccountPage = () => {
  const navigate = useNavigate();

  return (
    <Flex justify="center" align="center" flex={1} px={2} py={20}>
      <VStack w="full" maxW="600px" gap={6}>
        <EmptyState
          title="アカウント作成機能は提供されていません"
          description="新規アカウントの作成は管理者が行います。アカウントの発行をご希望の場合は、システム管理者までお問い合わせください。"
          icon={<LuUserX />}
        />
        <Button colorPalette="teal" size="lg" w="80%" maxW="280px" onClick={() => navigate('/')}>
          <LuArrowLeft />
          トップに戻る
        </Button>
      </VStack>
    </Flex>
  );
};

export default CreateAccountPage;
